import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import CircularProgress from "@/components/common/CircularProgress";
import { useAcuityMigration } from "@/contexts/AcuityMigrationContext";

const AcuityMigrationWelcomeModal: React.FC = () => {
  const {
    isAcuity,
    isInProgress,
    isPendingReview,
    migratingDismissed,
    doneDismissed,
    dismissMigrating,
    dismissDone,
  } = useAcuityMigration();
  const navigate = useNavigate();

  // El estado "migrando" solo aplica para psicos Acuity activas.
  // El "done" depende solo de pending_review porque al terminar la migración el BE
  // cambia el external_tool a psi-platform → isAcuity pasa a false y el modal se cerraba antes de mostrar el done.
  const showMigrating = isAcuity && isInProgress && !migratingDismissed;
  const showDone = isPendingReview && !doneDismissed;
  const open = showMigrating || showDone;

  const handleClose = () => {
    if (showMigrating) dismissMigrating();
    else if (showDone) dismissDone();
  };

  const handleGoToCalendar = () => {
    dismissDone();
    navigate("/calendar?config=recurring");
  };

  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) handleClose(); }}>
      <DialogContent className="p-6 sm:max-w-md">
        {showMigrating ? (
          <div className="flex flex-col items-center text-center gap-4">
            <CircularProgress sizeRem={3} />
            <DialogTitle className="text-xl">¡Bienvenida a psi-platform!</DialogTitle>
            <DialogDescription className="text-base">
              Estamos trayendo tus horarios desde Acuity. Esto puede tardar unos segundos.
              Podés cerrar esta ventana y seguir usando la plataforma, la migración continúa en segundo plano.
            </DialogDescription>
            <Button variant="outline" onClick={handleClose} className="mt-2">Cerrar</Button>
          </div>
        ) : (
          <div className="flex flex-col items-center text-center gap-4">
            <div className="flex items-center justify-center w-12 h-12 rounded-full bg-green-100 text-green-600 text-2xl">✓</div>
            <DialogTitle className="text-xl">¡Listo!</DialogTitle>
            <DialogDescription className="text-base">
              Tus horarios ya fueron migrados. Pasá por tu agenda para revisarlos.
            </DialogDescription>
            <Button onClick={handleGoToCalendar} className="mt-2">Ver mi agenda</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AcuityMigrationWelcomeModal;
